import React, { PureComponent } from 'react';
import RotateImageContainer from '../../../../CommonComponents/Rotate180/RotateImageContainer';
import './DittoRotateImageConatiner.scss';

class DittoRotateImageConatiner extends PureComponent {
  render() {
    const { productData, rotateImgPath, headturnVisible, dataLocale } = this.props;
    return (
      <div aria-label={dataLocale.ROTATE_IMAGE_CONTAINER}>
        {headturnVisible && (
          <RotateImageContainer productData={productData} rotateImgPath={rotateImgPath} />
        )}
      </div>
    );
  }
}

export default DittoRotateImageConatiner;
